import styled from "styled-components";
import { apolloSpaceInlineHalfX } from "@nexthink/apollo-tokens";
import { StyledActionMenu } from "./ActionMenu.style";
export const StyledActionSubMenu = styled.div.withConfig({ displayName: "StyledActionSubMenu_APC-7281-productShell", componentId: "sc-1s4jsnb" })(({ theme }) => ({
    boxShadow: theme.colors.apolloBoxShadowTooltip2ndLevel,
    borderRadius: apolloSpaceInlineHalfX,
    overflow: "hidden",
    [`& ${StyledActionMenu}`]: {
        borderRadius: 0,
    },
}));
//# sourceMappingURL=ActionSubMenu.style.js.map